import { colors } from '@/utils';

// 🎨 Centralized color palette for the gamepad illustration
export const gamepadColors = {
  text: colors.text.neutral.contrast,

  stroke: colors.stroke.neutral[100],
  indexStroke: colors.stroke.neutral.solid[100],

  bodyFill: colors.surface.overlay,
  bodyAccentLight: colors.stroke.neutral[100],
  bodyPanelGray: colors.stroke.neutral[100],

  innerDarkGray: '#515151',
  innerDarkerGray: '#4a4a4a',
  innerMidGray: '#424242',
  innerMetalGray: '#898989',
  smallDetailGray: colors.stroke.neutral[50],
  labelGray: colors.text.neutral.on.soft[100],

  buttonYellow: '#ffcc00',
  buttonGreen: '#54ff00',
  buttonBlue: '#0006ff',
  buttonRed: '#ff0000',
  buttonLime: '#9cff00',

  letterA: '#00af00',
  letterB: '#af0000',
  letterY: '#af9600',
  letterX: '#0000af',
};
